/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WeaknessMappingDto
 */
export interface WeaknessMappingDto {
    /**
     * 
     * @type {string}
     * @memberof WeaknessMappingDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessMappingDto
     */
    mappingType?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessMappingDto
     */
    platformOrScannerType?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessMappingDto
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessMappingDto
     */
    canonicalWeaknessId?: string;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessMappingDto
     */
    syncedAt?: Date;
}

/**
 * Check if a given object implements the WeaknessMappingDto interface.
 */
export function instanceOfWeaknessMappingDto(value: object): value is WeaknessMappingDto {
    return true;
}

export function WeaknessMappingDtoFromJSON(json: any): WeaknessMappingDto {
    return WeaknessMappingDtoFromJSONTyped(json, false);
}

export function WeaknessMappingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeaknessMappingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'mappingType': json['mappingType'] == null ? undefined : json['mappingType'],
        'platformOrScannerType': json['platformOrScannerType'] == null ? undefined : json['platformOrScannerType'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'canonicalWeaknessId': json['canonicalWeaknessId'] == null ? undefined : json['canonicalWeaknessId'],
        'syncedAt': json['syncedAt'] == null ? undefined : (new Date(json['syncedAt'])),
    };
}

export function WeaknessMappingDtoToJSON(json: any): WeaknessMappingDto {
    return WeaknessMappingDtoToJSONTyped(json, false);
}

export function WeaknessMappingDtoToJSONTyped(value?: WeaknessMappingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'mappingType': value['mappingType'],
        'platformOrScannerType': value['platformOrScannerType'],
        'externalId': value['externalId'],
        'canonicalWeaknessId': value['canonicalWeaknessId'],
        'syncedAt': value['syncedAt'] == null ? undefined : ((value['syncedAt']).toISOString()),
    };
}

